module.exports = __webpack_public_path__ + "static/media/arrow-down-v2.7fa61a89.svg";